module.exports = __webpack_public_path__ + "static/Rectangle-5b5b7ec3c2aaf820e130408c676a3bc2.png";